import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../site-settings-list/model/site-settings-list.constants";
import { editSiteSettings } from "./site-settings-edit.component.service";
import { getSiteSettingsInputs } from "../model/site-settings.modal";
import SiteSettingsEditTemplateComponent from "./site-settings-edit-template.component";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  SITE_SETTINGS_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const SiteSettingsEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let siteSettingsPayload = {};
    for (let i = 0; i < values.length; i++) {
      siteSettingsPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const siteSettingsResponse = await editSiteSettings(
      location?.state?.row?.id,
      siteSettingsPayload
    );

    // INFO : check api response and show relevant alert message
    if (siteSettingsResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: siteSettingsResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getSiteSettingsInputs({
      company_name: location?.state?.row?.company_name || "",
      header_logo: location?.state?.row?.header_logo || "",
      contact_number: location?.state?.row?.contact_number || "",
      contact_email: location?.state?.row?.contact_email || "",
      address: location?.state?.row?.address || "",
      footer_logo: location?.state?.row?.footer_logo || "",
      footer_description: location?.state?.row?.footer_description || "",
      footer_customer_service: location?.state?.row?.footer_customer_service || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <SiteSettingsEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default SiteSettingsEditComponent;
